import styled from "styled-components";

export const Wrap = styled.div`
  padding: 8px 4px 32px;
`;

export const Intro = styled.p`
  margin: 0 0 20px;
  color: #66758a;
  font-size: 13px;
  max-width: 640px;
`;

export const CardsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(140px, 1fr));
  gap: 14px;
  margin-bottom: 24px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(140px, 1fr));
  }
`;

export const Card = styled.div`
  padding: 16px 18px;
  border: 1px solid #dde2e9;
  border-radius: 12px;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const CardLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #66758a;
  text-transform: uppercase;
  letter-spacing: 0.03em;
`;

export const CardValue = styled.span`
  font-size: 24px;
  font-weight: 700;
  color: #172033;
`;

export const SectionTitle = styled.h3`
  margin: 0 0 12px;
  font-size: 15px;
  font-weight: 700;
  color: #172033;
`;

export const TableWrap = styled.div`
  border: 1px solid #dde2e9;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
  margin-bottom: 28px;
`;

export const EmptyState = styled.div`
  padding: 40px 20px;
  text-align: center;
  color: #94a3b8;
`;
